
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 40 40"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 6a14 14 0 00-5.1 27 13.58 13.58 0 010-4c.25-1.09 1.64-7 1.64-7a5.05 5.05 0 01-.37-2c0-1.94 1.13-3.4 2.53-3.4a1.76 1.76 0 011.77 2c0 1.2-.76 3-1.16 4.66a2 2 0 002.08 2.53c2.49 0 4.4-2.63 4.4-6.41a5.53 5.53 0 00-5.85-5.7 6.06 6.06 0 00-6.32 6.08 5.42 5.42 0 001 3.19.42.42 0 01.1.4c-.11.44-.34 1.4-.39 1.59s-.2.31-.47.19c-1.75-.82-2.84-3.37-2.84-5.43 0-4.41 3.21-8.47 9.25-8.47 4.86 0 8.63 3.46 8.63 8.09 0 4.82-3 8.71-7.26 8.71a3.74 3.74 0 01-3.21-1.61s-.7 2.67-.88 3.33a15.17 15.17 0 01-1.74 3.67A14.22 14.22 0 0020 34a14 14 0 000-28z"}})])
          )
        }
      }
    